export const seralizeTemplateData = (state) => {
  const {
    templates,
    templateProgressType,
    form,
    formConfig,
    reviewAndEmbed,
    integration,
  } = state;
  return {
    id: templates.currentTemplate.id,
    title: templates.currentTemplate.title,
    description: form.description,
    templateType: templates.currentTemplate.templateType,
    imageUrl: templates.currentTemplate.imageUrl,
    progressType: templateProgressType,
    form: {
      title: form.title,
      description: form.description,
      submissionConfig: { ...formConfig },
      fields: [...form.dropped],
      submitBtnConfig: { ...form.submitConfig },
    },
    integration: {
      configType: integration.configType,
      webhooks: serializeWebhooks(integration),
    },
    reviewAndEmbed: { ...reviewAndEmbed },
  };
};

const serializeWebhooks = (integration) => {
  const webhooks = [];
  integration.webhooks.forEach((webhook) => {
    webhooks.push(serializeWebhook(webhook));
  });
  return webhooks;
};

const serializeWebhook = (webhook) => {
  const headers = {};
  //const responseBody = {};

  webhook[4].forEach((header, index) => {
    const [key, value] = [
      header["resHeaderKey_" + index],
      header["resHeaderValue_" + index],
    ];
    if (key && value) {
      headers[key] = value;
    }
  });

  // webhook[5].forEach((body, index) => {
  //   const [key, value] = [
  //     body["resBodyKey_" + index],
  //     body["resBodyValue_" + index],
  //   ];
  //   if (key && value) {
  //     responseBody[key] = value;
  //   }
  // });

  return {
    name: webhook[0],
    url: webhook[1],
    method: webhook[2],
    requestType: webhook[3],
    headers,
    //responseBody,
  };
};
